"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPickupRouteEventUpdate = exports.DeliveryPickupRouteEventCreate = exports.DeliveryPickupRouteEventQuery = exports.DeliveryPickupRouteEventTransport = exports.DeliveryPickupRouteEvent = exports.ContainerDeliveryRemovalMetadata = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const DeliveryPickupEventResolution_1 = require("./DeliveryPickupEventResolution");
exports.ContainerDeliveryRemovalMetadata = typebox_1.Type.Object({
    containerID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Integer({ minimum: 1 }),
    forSubscriptionEquipmentID: typebox_1.Type.String({ format: 'uuid' }),
    type: typebox_1.Type.Union([typebox_1.Type.Literal('DELIVERY'), typebox_1.Type.Literal('REMOVAL')]),
});
exports.DeliveryPickupRouteEvent = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // breadcrumb: DeliveryPickupRouteBreadcrumb,
    deliveryPickupBreadcrumbID: typebox_1.Type.String({ format: 'uuid' }),
    // atPlannedStop: Type.Optional(DeliveryPickupPlannedStop),
    atDeliveryPickupPlannedStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    resolved: typebox_1.Type.Boolean(),
    deliveryPickupEventResolution: typebox_1.Type.Optional(DeliveryPickupEventResolution_1.DeliveryPickupEventResolution),
    // resolutionID: Type.Optional(Type.String({ format: 'uuid' })),
    fromDeliveryPickupRouteID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    affectedQuantity: typebox_1.Type.Integer(),
    actionRequired: typebox_1.Type.Boolean(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryPickupEventType: enums_1.DeliveryPickupRouteEventType,
    s3ItemRefs: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    deliveryRemovalMetadata: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ContainerDeliveryRemovalMetadata)),
    metadata: common_1.MetaData,
});
exports.DeliveryPickupRouteEventTransport = exports.DeliveryPickupRouteEvent;
exports.DeliveryPickupRouteEventQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        breadcrumbID: typebox_1.Type.String({ format: 'uuid' }),
        hasPlannedStop: typebox_1.Type.Boolean(),
        atPlannedStopID: typebox_1.Type.String({ format: 'uuid' }),
        resolved: typebox_1.Type.Boolean(),
        resolutionID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.DeliveryPickupRouteEventCreate = typebox_1.Type.Omit(exports.DeliveryPickupRouteEvent, [
    'id',
    'haulerID',
    'deliveryPickupBreadcrumbID',
    'atDeliveryPickupPlannedStopID',
    'deliveryPickupEventResolution',
    'resolved',
    'fromDeliveryPickupRouteID',
    'metadata',
]);
exports.DeliveryPickupRouteEventUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.DeliveryPickupRouteEvent, [
    'id',
    'haulerID',
    'customerID',
    'deliveryPickupBreadcrumbID',
    'atDeliveryPickupPlannedStopID',
    'deliveryPickupEventResolution',
    'resolved',
    'fromDeliveryPickupRouteID',
    'deliveryRemovalMetadata',
    'metadata',
]));
//# sourceMappingURL=DeliveryPickupRouteEvent.js.map